import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import * as ReactBootstrap from 'react-bootstrap'
export class SelectableTable extends React.Component {
  constructor(props) {
    super(props)
    this.mySubmitHandler = this.mySubmitHandler.bind(this)
    this.myChangeHandler = this.myChangeHandler.bind(this)
    this.state = {
      search: '',
    }
    this.onSubmit = this.onSubmit.bind(this)
  }
  onSubmit(event) {
    event.preventDefault()
    this.props.onFilter(this.state)
  }
  mySubmitHandler(event) {
    event.preventDefault()
    this.onSubmit(this.state)
  }
  myChangeHandler(event) {
    this.setState({ [event.target.name]: event.target.value }, () => {})
  }
  render() {
    const { columns, items, OnSelectionChanged, myChangeHandler } = this.props
    const selectRow = {
      mode: 'radio',
      bgColor: '#00BFFF',
      clickToSelect: true,
      onSelect: (row, isSelect, rowIndex, e) => {
        OnSelectionChanged(row)
      },
      selectColumnStyle: ({ checked, disabled, rowIndex, rowKey }) => {
        if (checked) {
          return {
            backgroundColor: 'green',
          }
        }
        return {
          backgroundColor: 'pink',
        }
      },
    }
    return (
      <ReactBootstrap.Col xs="12">
        {myChangeHandler ? (
          <ReactBootstrap.Form.Group key={'search'} controlId={'search'}>
            <ReactBootstrap.Form.Label key={'Search'}>
              Search
            </ReactBootstrap.Form.Label>
            <ReactBootstrap.Form.Control
              name={'search'}
              key={'search'}
              onChange={this.myChangeHandler}
              placeholder={'Enter Search Value'}
            />
            <br />{' '}
            <ReactBootstrap.Button
              variant="outline-dark"
              size="sm"
              onClick={this.onSubmit}
              className="float-end"
            >
              Search
            </ReactBootstrap.Button>
            <br />
          </ReactBootstrap.Form.Group>
        ) : (
          ''
        )}
        <br />
        {items.length ? (
          <BootstrapTable
            keyField={'url'}
            data={items}
            columns={columns}
            selectRow={selectRow}
          />
        ) : (
          <ReactBootstrap.Alert variant="info">
            No results found..
          </ReactBootstrap.Alert>
        )}
      </ReactBootstrap.Col>
    )
  }
}
